import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFeatureIsOn } from 'src/common/growthbook';
import { B2BUserHelper } from 'src/common/helpers';
import { useGetUserQuery } from 'src/common/slices';

const ExperimentRoomReplacementMap = new Map<string, string>([['offensivesecurityintro', 'offensivesecurityintrokK']]);

export const useRoomCode = () => {
  const isFeatureOn = useFeatureIsOn('improvement-offensive-security-intro');
  const { data: userData } = useGetUserQuery();
  const { isBusinessUser } = B2BUserHelper(userData?.data?.user);
  const isExperimentEnabled = isFeatureOn && userData && !isBusinessUser;
  const { roomCode: originalRoomCode } = useParams();

  return useMemo(() => {
    if (!isExperimentEnabled || !originalRoomCode) {
      return originalRoomCode;
    }
    return ExperimentRoomReplacementMap.has(originalRoomCode)
      ? ExperimentRoomReplacementMap.get(originalRoomCode)
      : originalRoomCode;
  }, [isExperimentEnabled, originalRoomCode]);
};
